import { BetaFeature } from 'prove-common'
import { WORKSPACE_BETA_FEATURE_KEY } from './workspaces/workspaces'

export const TASKS_BETA_FEATURE_KEY = 'tasks'

export const betaFeatures: BetaFeature[] = [
  {
    key: WORKSPACE_BETA_FEATURE_KEY,
    title: 'Arbeidsområder (beta)',
    description:
      'Slår på arbeidsområder for fagseksjoner og tilsynsdivisjoner basert på dine tilganger i Prøveplan.'
  },
  {
    key: TASKS_BETA_FEATURE_KEY,
    title: 'Oppgaver (beta)',
    description: 'Slår på den nye oppgaveoversikten i Prøveplan.'
  }
]
